import { Suspense } from 'react';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { Dashboard as DashboardView } from '@modules/Tributes/Views/Dashboard/Dashboard';

export const TributesDashboard: React.FC = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%" />}>
        <DashboardView />
      </Suspense>
    </ErrorBoundary>
  );
};